(function () {
  'use strict';

  const { iman, BaseCarousel, GalleryCard, ModalProduct } = window.Universe;

  class ProductsFilters {
    constructor(section, parent) {
      if (!section || !parent) return;
      this.init(section, parent);
    }

    setup() {
      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carousel: this.DOM.section,
        carouselOptions: {
          containScroll: 'trimSnaps',
          align: 'start'
        },
        onReady: () => {}
      });
    }

    destroy() {
      if (this.DOM) {
        if (this.instance) this.instance.destroy();
        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section, parent) {
      this.DOM = {};
      this.DOM.parent = parent;
      this.DOM.section = section;
      this.setup();
    }
  }

  class FeaturedProducts {
    constructor(section, parent) {
      if (!section || !parent) return;
      this.init(section, parent);
    }

    setup() {
      const isMobileEnabled = this.DOM.section.dataset.mobileEnabled;
      const isDesktopEnabled = this.DOM.section.dataset.desktopEnabled;

      this.instance = new BaseCarousel({
        wrap: this.DOM.parent,
        carousel: this.DOM.section,
        carouselOptions: {
          containScroll: 'trimSnaps',
          dragFree: true,
          align: 'start',
          loop: false,
          active: isDesktopEnabled === 'true',
          breakpoints: {
            '(max-width:768px)': { active: isMobileEnabled === 'true' }
          }
        },
        onReady: () => {
          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          this.setupCards();
          this.setupAccessibility();

          this.instance.instance.on('select', this.onSelect);

          // Keyboard navigation
          this.DOM.parent.addEventListener('keydown', this.onKeyDown);

          this.isKeyboardInteraction = false;
        }
      });
    }

    setupCards() {
      this.DOM.cards = this.DOM.parent.querySelectorAll('.js-gallery-card');
      this.DOM.quickAdd = document.querySelector('.js-quick-add-container');

      if (this.DOM.cards) {
        this.cards = [];
        this.quickAdds = [];

        this.DOM.cards.forEach((card) => {
          const cardInstance = new GalleryCard(card);
          this.cards.push(cardInstance);

          if (this.DOM.quickAdd) {
            const cardQuickAdd = new ModalProduct(card, this.DOM.quickAdd);
            this.quickAdds.push(cardQuickAdd);
          }
        });
      }
    }

    destroyCards() {
      if (this.cards) {
        this.cards.forEach((card) => { card.destroy(); });
      }
      if (this.quickAdds) {
        this.quickAdds.forEach((quickAdd) => { quickAdd.destroy(); });
      }
      this.cards = undefined;
      this.quickAdds = undefined;
      this.DOM.cards = undefined;
      this.DOM.quickAdds = undefined;
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        // Remove keyboard navigation
        this.DOM.parent.removeEventListener('keydown', this.onKeyDown);

        // Remove announcer
        if (this.DOM.announcer) {
          this.DOM.announcer.remove();
        }

        if (this.instance.instance) {
          this.instance.instance.off('select', this.onSelect);
        }
        this.instance.destroy();
        this.destroyCards();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    focusActiveCard() {
      const embla = this.instance.instance;
      const currentSnap = embla.selectedScrollSnap();
      const slidesInView = embla.slidesInView();

      if (slidesInView.length > 0) {
        const targetSlideIndex = slidesInView[0];
        const targetSlide = embla.slideNodes()[targetSlideIndex];

        if (targetSlide) {
          const focusable = targetSlide.querySelector('a, button, [tabindex="0"]');
          if (focusable) {
            focusable.focus();
          } else if (targetSlide.tagName === 'A' || targetSlide.hasAttribute('tabindex')) {
            targetSlide.focus();
          }
        }
      }
    }

    setupAccessibility() {
      this.DOM.announcer = document.createElement('div');
      this.DOM.announcer.setAttribute('aria-live', 'polite');
      this.DOM.announcer.setAttribute('aria-atomic', 'true');
      this.DOM.announcer.className = 'sr-only';
      this.DOM.announcer.style.cssText =
        'position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;';
      this.DOM.parent.appendChild(this.DOM.announcer);
    }

    announceSlideChange() {
      if (!this.DOM.announcer) return;

      const embla = this.instance.instance;
      const currentSnap = embla.selectedScrollSnap();
      const totalSnaps = embla.scrollSnapList().length;

      const template = window.featuredCollectionStrings?.productsAnnouncement || 'Showing products starting from set [current] of [total]';
      this.DOM.announcer.textContent = template.replace('[current]', currentSnap + 1).replace('[total]', totalSnaps);
    }

    init(section, parent) {
      this.DOM = {};
      this.DOM.parent = parent;
      this.DOM.section = section;

      this.DOM.prev = this.DOM.parent.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.parent.querySelectorAll('.js-carousel-next');

      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };
      this.onNext = () => {
        this.instance.instance.scrollNext();
      };
      this.onSelect = () => {
        this.announceSlideChange();
        if (this.isKeyboardInteraction) {
          this.focusActiveCard();
          this.isKeyboardInteraction = false;
        }
      };
      this.onKeyDown = (e) => {
        if (!this.DOM.parent.contains(document.activeElement)) return;

        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            this.isKeyboardInteraction = true;
            this.onPrev();
            break;
          case 'ArrowRight':
            e.preventDefault();
            this.isKeyboardInteraction = true;
            this.onNext();
            break;
        }
      };

      this.setup();
    }
  }

  class FeaturedCollection {
    constructor(section) {
      this.init(section);
    }

    setup() {
      const cardsCarousel = new FeaturedProducts(this.DOM.carousel, this.DOM.parent);
      this.carousels.push(cardsCarousel);
      this.setupFilters();
    }

    setupFilters() {
      if (this.DOM.filtersContainer && this.DOM.cards) {
        this.carousels.push(new ProductsFilters(this.DOM.filtersContainer, this.DOM.parent));

        this.DOM.filters = this.DOM.filtersContainer ? this.DOM.filtersContainer.querySelectorAll('.js-featured-collection-filter') : null;

        const filters = [];
        const cards = Array.from(this.DOM.cards);
        const carouselWrap = this.DOM.carousel.querySelector('.js-carousel');
        const maxCardCount = Number(carouselWrap.dataset.max);
        let firstActivationExecuted = false;

        const stash = document.createElement('div');
        stash.hidden = true;
        this.DOM.carousel.appendChild(stash);

        if (!this.DOM.filters || this.DOM.filters.length === 0) {
          // Single collection: no filter buttons, activate all view-all buttons immediately
          this.DOM.viewAlls.forEach((button) => {
            button.classList.add('featured-collection__view-all--active');
          });
          return;
        }

        if (this.DOM.filters && this.DOM.filters.length > 0) {
          this.DOM.filters.forEach((filter) => {
            const filterColl = filter.getAttribute('data-collection');

            filters.push({ id: filterColl, isActive: false });

            const handleFilterActivation = () => {
              let activeFilter = undefined;

              filters.forEach((f) => {
                if (f.id === filterColl) {
                  f.isActive = true;
                  activeFilter = f;
                } else {
                  f.isActive = false;
                }
              });

              if (this.DOM.filters) {
                this.DOM.filters.forEach((f) => {
                  const fColl = f.getAttribute('data-collection');
                  if (fColl === filterColl) f.classList.add('featured-collection__filter--active');
                  else f.classList.remove('featured-collection__filter--active');
                });
              }

              this.DOM.viewAlls.forEach((button) => {
                if (button.dataset.collection == activeFilter.id) {
                  button.classList.add('featured-collection__view-all--active');
                } else {
                  button.classList.remove('featured-collection__view-all--active');
                }
              });

              cards.forEach((card) => { stash.appendChild(card); });

              let visibleCount = 0;

              cards.forEach((card) => {
                const cardCollsString = card.getAttribute('data-collections');

                if (!cardCollsString || cardCollsString === '') {
                  carouselWrap.appendChild(card);
                  return;
                }

                const cardColls = cardCollsString.split(',');
                const flag = cardColls.some((coll) => { return coll.trim() === activeFilter.id; });

                if ((activeFilter.id === 'all' || flag) && visibleCount < maxCardCount) {
                  carouselWrap.appendChild(card);
                  visibleCount++;
                }
              });

              if (this.carousels[0] && this.carousels[0].instance && this.carousels[0].instance.instance) {
                this.carousels[0].instance.instance.reInit();
              }
            };

            filter.addEventListener('click', handleFilterActivation);

            if (!firstActivationExecuted) {
              handleFilterActivation();
              firstActivationExecuted = true;
            }
          });

          filters[0].isActive = true;
        }
      }
    }

    destroy() {
      if (this.DOM) {
        if (this.carousels) {
          this.carousels.forEach((carousel) => { carousel.destroy(); });
        }
        this.carousels = [];
        this.DOM = undefined;
      }
    }

    init(section) {
      if (section) {
        this.DOM = {};
        this.DOM.parent = section;
        this.sectionId = section.closest('.shopify-section')?.id || null;
        this.DOM.filtersContainer = this.DOM.parent.querySelector('.js-featured-collection-filters');
        this.DOM.filters = undefined;
        this.DOM.carousel = this.DOM.parent.querySelector('.js-featured-collection-carousel');
        this.DOM.cards = this.DOM.carousel.querySelectorAll('.js-carousel-slide');
        this.DOM.viewAlls = this.DOM.carousel.querySelectorAll('.js-featured-collection-view_all');
        this.DOM.quickAdd = document.querySelector('.js-quick-add-container');

        this.carousels = [];

        if (this.DOM.carousel) {
          this.setup();
        } else {
          console.warn('No carousel found in FeaturedGallery');
        }
      }
    }
  }

  class FeaturedCollections {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.instances.push(new FeaturedCollection(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);
      if (!this.DOM) { this.DOM = {}; this.instances = []; }
      const newSections = sectionEl.querySelectorAll('.js-featured-collection');
      for (let i = 0; i < newSections.length; i++) {
        this.instances.push(new FeaturedCollection(newSections[i]));
      }
      this.DOM.sections = document.querySelectorAll('.js-featured-collection');
    }

    destroySection(sectionEl) {
      if (!this.instances) return;
      const targetId = sectionEl.id || sectionEl.closest('.shopify-section')?.id;
      if (!targetId) return;
      for (let i = this.instances.length - 1; i >= 0; i--) {
        const instance = this.instances[i];
        if (instance.sectionId === targetId) {
          instance.destroy();
          this.instances.splice(i, 1);
        }
      }
    }

    onBlockSelect(blockEl) {
      for (let i = 0; i < this.instances.length; i++) {
        const item = this.instances[i];
        if (item.DOM && item.DOM.parent && item.DOM.parent.contains(blockEl)) {
          const slide = blockEl.closest('.js-carousel-slide');
          if (!slide) break;

          const emblaApi = item.carousels && item.carousels[0] && item.carousels[0].instance ? item.carousels[0].instance.instance : null;
          if (emblaApi) {
            const slides = emblaApi.slideNodes();
            const slideIndex = Array.from(slides).indexOf(slide);
            if (slideIndex !== -1) {
              const autoplay = emblaApi.plugins().autoplay;
              if (autoplay) autoplay.stop();
              emblaApi.scrollTo(slideIndex);
            }
          }
          break;
        }
      }
    }

    onBlockDeselect(blockEl) {
      for (let i = 0; i < this.instances.length; i++) {
        const item = this.instances[i];
        if (item.DOM && item.DOM.parent && item.DOM.parent.contains(blockEl)) {
          const emblaApi = item.carousels && item.carousels[0] && item.carousels[0].instance ? item.carousels[0].instance.instance : null;
          if (emblaApi) {
            const autoplay = emblaApi.plugins().autoplay;
            if (autoplay) autoplay.play();
          }
          break;
        }
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container) {
      container = container || document;
      const sections = container.querySelectorAll('.js-featured-collection');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;
        this.instances = [];
        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('featuredCollections')) {
      iman.add('featuredCollections', new FeaturedCollections());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.FeaturedCollections = FeaturedCollections;
})();
